import React from 'react'
import classNames from 'classnames'


export default function Tab(props) {
  return (
    <div className={classNames(
      'flex justify-center border-b',
      props.className,
    )}>
      {props.children}
    </div>
  )
}

const Item = props => {
  return (
    <div
      onClick={
        e => {
          e.preventDefault()
          props.onChange()
        }
      }
      className={classNames(
        'cursor-pointer',
        'btn-base p-3 -mb-px rounded-t-lg border-r border-t border-l',
        {'border-disabled-200 bg-white': props.selected},
        {'border-transparent': !props.selected},
      )}
    >{props.children}</div>
  )
}

Tab.Item = Item
